import { post, get } from './requests'

export const getEngagementEntries = key =>
  get(['api', 'engagement-entry'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const createEngagementEntry = key => payload =>
  post(
    ['api', 'engagement-entry'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )



// WEBPACK FOOTER //
// ./src/services/engagements.js